export default "__VITE_ASSET__fMdGxQWo__"